/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/**
 * This component is used to separate the logic of selection of items,
 * in this way if the template of forms and list of networks changes or the logic of selection changed,
 * it is easier to update
 */
var $ = require('jquery');
var groupService = require('./group.service');

function getSelectedForm(code) {
    return '#' + code + 'form';
}

function getButtonClass() {
    return '.registered-account, .preset-account, .available-network';
}

function getAllAccountsButton() {
    return '.registered-account input:radio.payment-option-radio';
}
function getPresetAccountButton() {
    return '.preset-account input:radio.payment-option-radio';
}

function getAllNetworksButton() {
    return '.available-network input:radio.payment-option-radio';
}

function getAllGroupedNetworkLabel() {
    return '.available-network.grouped-network label';
}

function getAllGroupedNetworkSelect() {
    return '.available-network.grouped-network select';
}

function getFormContainerId(code, networks) {
    var formContainerPrefix = '#formContainer';
    var networkGroup = groupService.getGroup(code, networks);
    if (!networkGroup || !(networks && networks[networkGroup] && networks[networkGroup][0] && networks[networkGroup][0].networkCode)) {
        return formContainerPrefix + code;
    }
    return formContainerPrefix + networks[networkGroup][0].networkCode;
}

function getSmartSwitchCurrentNetwork(groupType, isIframe) {
    if (isIframe) {
        return $('.formContainer' + groupType + ' iframe').attr('data-loaded');
    }
    var loadedFromId = $('.formContainer' + groupType + ' .form').attr('id');

    return loadedFromId.substring(0, loadedFromId.lastIndexOf('form'));
}

module.exports = {
    getButtonClass: getButtonClass,
    getSelectedForm: getSelectedForm,
    getFormContainerId: getFormContainerId,
    getSmartSwitchCurrentNetwork: getSmartSwitchCurrentNetwork,
    getAllAccountsButton: getAllAccountsButton,
    getAllNetworksButton: getAllNetworksButton,
    getPresetAccountButton: getPresetAccountButton,
    getAllGroupedNetworkLabel: getAllGroupedNetworkLabel,
    getAllGroupedNetworkSelect: getAllGroupedNetworkSelect,
};
